import {FC} from 'react'
import {SelectAsync} from '../../SelectV2'
type Props = {
  keySelect?: string
  name: string
  disabled?: boolean
  required?: boolean
  loadOptions?: any
  value?: any
  labelText?: string
  onChangeValue?: (e: any) => void
  textPlaceholder?: string
}
const SelectWrapper: FC<Props> = ({
  keySelect,
  name,
  disabled,
  required,
  labelText,
  onChangeValue,
  textPlaceholder,
  loadOptions,
  value
}) => {
  let classLabel = required ? 'required' : ''
  return (
    <div>
      <label className={classLabel}>{labelText}:</label>
      <SelectAsync
        keySelect={keySelect}
        name={name}
        disabled={disabled}
        onChangeValue={onChangeValue}
        textPlaceholder={textPlaceholder}
        loadOptions={loadOptions}
        value={value}
      />
    </div>
  )
}

export default SelectWrapper
